// extracted by mini-css-extract-plugin
export var label = "_dr-5";
export var slideContainer = "_dr-0";
export var slider = "_dr-1";
export var sliderLg = "_dr-4";
export var sliderMd = "_dr-3";
export var sliderSm = "_dr-2";